/**
 * HA-858 (S4) — the tip "Refund the tip too?" offers on a full refund, in pence, as the server honours it: a card refund walks
 * each completed card payment and can hand back each one's tip; any other refund reaches the order's one payment, if it was
 * paid once. 0 means there is no tip to offer.
 */
export function refundableTip(
	payments: {
		method: string;
		status: string;
		tip?: { value: number } | null;
	}[],
	method: string,
): number {
	const completed = payments.filter((p) => p.status === "Completed");

	if (method === "card")
		return completed
			.filter((p) => p.method === "card")
			.reduce((sum, p) => sum + (p.tip?.value ?? 0), 0);

	return completed.length === 1 ? (completed[0]?.tip?.value ?? 0) : 0;
}
